export function hasDataLayer() {
  return 'dataLayer' in window;
}
